import { transport } from 'config/transport';

export function callApiExportCongDoanMonthlyReport(congDoanId, yearMonth, pdf = false, submitToTW = false) {
    return transport.get(`/congdoan/${congDoanId}/thuchi/exportReport`, { params: { yearMonth, pdf, submitToTW }, responseType: 'blob' });
}
